import { MJPromotion } from "../main/promotion3.js";

class Core {
  constructor() {
    this.currentTimeout = null;
  }
  promotion(object) {
    new MJPromotion(object);
  }
  wait(timeout) {
    if (this.currentTimeout) clearTimeout(this.currentTimeout);
    return new Promise((resolve) => {
      this.currentTimeout = setTimeout(resolve, timeout);
    });
  }
}

window.addEventListener("load", function () {
  const dndPromotion = new Core().promotion;
  const core = new Core();

  const $centerCard = $("#frame2 .center-card");

  // Mặc định mở bảng nhiệm vụ khi load
  $("#frame2 .table__condition").addClass("is-active");

  const SPIN_DURATION = 1200;
  const promotionConfig = { timeWait: SPIN_DURATION };

  // Spin ngay khi click (không chờ AJAX)
  $(document).on("click", "#frame2 .btn-action.pm__rut", function () {
    if (!$centerCard.length) return;
    $centerCard.removeClass("spinning");
    void $centerCard[0].offsetWidth; // force reflow để restart animation
    $centerCard.addClass("spinning");
  });

  // Toggle bảng nhiệm vụ: mặc định ẩn; click btn-nhiemvu để mở/đóng
  $(document).on("click", "#frame2 .btn-nhiemvu", function (e) {
    e.preventDefault();
    $("#frame2 .table__condition").toggleClass("is-active");
  });

  // Click btn-thele → đóng bảng nhiệm vụ + mở popup Thể lệ
  $(document).on("click", "#frame2 .btn-thele", function (e) {
    e.preventDefault();
    $("#frame2 .table__condition").removeClass("is-active");
    $(".popup").removeClass("active");
    $("#popup_rule").addClass("active");
  });

  // Click btn-gallery → scroll xuống frame4
  $(document).on("click", "#frame2 .btn-gallery", function (e) {
    e.preventDefault();
    const f4 = document.getElementById("frame4");
    if (!f4) return;
    const top = f4.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top, behavior: "smooth" });
  });

  dndPromotion({
    url: prodTemplate.url,
    debug: prodTemplate.debug,
    directory: prodTemplate.directory,
    items: prodTemplate.items,
    names: prodTemplate.names,
    config: promotionConfig,
    animResult: function (listPrize) {},
    callback: function () {
      $centerCard.removeClass("spinning");
      if (typeof prodTemplate.fnPromotion === "function") {
        prodTemplate.fnPromotion();
      }
    },
  });
});
